/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from "react";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import useUsuario from "./useUsuario";

const useGrupoSegmentoV2 = ({ trilha = 0, grupoSegmentoDisponiveis, permitir = 0 }) => {
  const { usuario } = useUsuario();
  const isCarteiraRecebedor = /\/carteira\/recebedor\/\d+/.test(window.location.pathname);

  const [gruposSegmentos, setGruposSegmentos] = useState([]);

  const distribuidor = useMemo(
    () => usuario?.slugAcessos.includes("acesso-ao-grupo-de-segmento-distribuidor"),
    [usuario]
  );
  const exportador = useMemo(() => usuario?.slugAcessos.includes("acesso-ao-grupo-de-segmento-exportador"), [usuario]);

  const fetchGruposSegmentos = async (signal) => {
    let query = db.grupoSegmento;
    const result = [];

    await query
      .filter((item) => {
        if (signal.aborted) return false;

        if (item.id === permitir) return true;

        return (
          item.ativo &&
          (!trilha || isCarteiraRecebedor || item.trilhaId === trilha) &&
          (!grupoSegmentoDisponiveis || grupoSegmentoDisponiveis.includes(item.id)) &&
          (distribuidor || !["400", "486"].includes(item.codigo)) &&
          (exportador || item.codigo !== "411")
        );
      })
      .each((item) => result.push(item));

    if (!signal.aborted) {
      setGruposSegmentos(result);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    fetchGruposSegmentos(signal);

    return () => controller.abort(); // Cancela a chamada anterior quando uma nova começa, pois uma estava afetando a outra
  }, [trilha, distribuidor, exportador, grupoSegmentoDisponiveis, isCarteiraRecebedor, permitir]);

  const optionsGrupoSegmento = useMemo(
    () =>
      prepareForOptions(
        (gruposSegmentos || []).sort((a, b) => a.nome.localeCompare(b.nome)),
        ["nome"],
        "id"
      ),
    [gruposSegmentos]
  );

  return {
    optionsGrupoSegmento,
  };
};

export default useGrupoSegmentoV2;
